{
  "endTime": "Beigu laiks",
  "startTime": "Sākuma laiks",
  "time": "Laiks"
}
